export class CoreEvents {
	public static readonly READY = 'READY';
	public static readonly SCROLL = 'SCROLL';
	public static readonly RESIZE = 'RESIZE';
	public static readonly TICK = 'TICK';
	public static readonly DOM_READY = 'DOM_READY';
	public static readonly DOM_UPDATED = 'DOM_UPDATED';
	public static readonly MODULE_MOUNTED = 'MODULE_MOUNTED';
	public static readonly MODULES_MOUNTED = 'MODULES_MOUNTED';
	public static readonly MODULE_DESTROYED = 'MODULE_DESTROYED';
	public static readonly BEHAVIOUR_MOUNTED = 'BEHAVIOUR_MOUNTED';
}
